import NotificationsPage from './NotificationsPage';
import { ReactComponent as NotificationsIcon } from '../icons/main_menu/notifications.svg';
import RuleIcon from '@mui/icons-material/Rule';
import FormatLineSpacingIcon from '@mui/icons-material/FormatLineSpacing';

const exports = {
    Page: NotificationsPage,
    Icon: NotificationsIcon,
    RulesetIcon: RuleIcon,
    StringIcon: FormatLineSpacingIcon,
};
export default exports;
